module.exports = __webpack_public_path__ + "static/media/branch-manager.a1009386.svg";